import React from 'react';
import toast from 'react-hot-toast';
import { Box, TextField, Typography } from '@mui/material';
import type { User } from '@core/api/user';
import Dialog from './Dialog';

export interface PlainPasswordDialogProps {
  open: boolean;
  user: User;
  onClose: () => void;
}

const PlainPasswordDialog: React.FC<PlainPasswordDialogProps> = ({
  open,
  user,
  onClose,
}) => {
  const { firstName, lastName, plainPassword } = user;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(plainPassword ?? '');
      toast.success('Password copied to clipboard');
    } catch {
      toast.error('Failed to copy password');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Password"
      onSubmitClick={handleCopy}
      submitText="Copy Password"
      cancelText="Close"
      maxWidth="xs"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Share this password with {firstName} {lastName}. It will not be shown
          again.
        </Typography>
        <TextField
          value={plainPassword ?? ''}
          fullWidth
          slotProps={{ input: { readOnly: true } }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: (theme) => theme.typography.h3.fontSize,
              fontWeight: 'bold',
              textAlign: 'center',
            },
          }}
        />
      </Box>
    </Dialog>
  );
};

export default PlainPasswordDialog;
